import { Component, output } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import LocalizationConstants from "src/app/constants/localization-constants";
import { ModalComponent, ModalService } from "src/app/services/modal.service";

export type ApprovedPriceResult = { value: string; poMandatory: boolean };

@Component({
  selector: "app-approved-service-price-modal",
  templateUrl: "./approved-service-price-modal.component.html",
  standalone: false,
})
export class ApprovedServicePriceModalComponent
  implements ModalComponent<ApprovedServicePriceModalComponent, void, ApprovedPriceResult>
{
  localizationConstants = LocalizationConstants;

  addNewItem = output<ApprovedPriceResult>();

  constructor(
    public dialogRef: MatDialogRef<ApprovedServicePriceModalComponent, ApprovedPriceResult>,
    public modalService: ModalService,
  ) {}

  submitResult(result: ApprovedPriceResult) {
    this.dialogRef.close(result);
  }
}
